(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-badges"] && !Shopify.designMode) return;
  try {
    (function() {
    const ThemeEvents = {
      variantUpdate: 'theme:variant-update'
    };

    function roundToNearestTen(percentage) {
      return Math.round(percentage / 10) * 10;
    }

    function parsePrice(priceText) {
      // Remove "$ " (dollar sign and space), then remove any remaining non-numeric characters except decimal point
      // Handle formats like "$ 89.00" or "$89.00"
      const cleaned = priceText.replace(/\$\s*/, '').replace(/[^\d.,]/g, '').replace(',', '');
      return parseFloat(cleaned) || 0;
    }

    function updateBadgeFromB4B(badgeElement, productCard) {
      if (!badgeElement || !productCard) return false;

      // First, check if compare-at-price element exists - if not, hide badge and return
      if (checkAndHideBadgeIfNoComparePrice(badgeElement, productCard)) {
        return false;
      }

      // Check if both b4b elements exist - if not, hide badge and return
      if (checkAndHideBadgeIfB4BElementsMissing(badgeElement, productCard)) {
        return false;
      }

      // Search for b4b price elements - try multiple locations
      const priceContainer = productCard.querySelector('product-price [ref="priceContainer"]') ||
                             productCard.querySelector('[ref="priceContainer"]');
      
      if (!priceContainer) {
        badgeElement.style.display = 'none';
        return false;
      }
      
      // Find the elements INSIDE the priceContainer
      // .b4b-vprice is the original price
      // .b4b-compare-at-price is the sale price
      const b4bPrice = priceContainer.querySelector('.b4b-vprice');
      const b4bCompareAtPrice = priceContainer.querySelector('.b4b-compare-at-price');
      
      // If either is missing, hide the entire badge
      if (!b4bPrice || !b4bCompareAtPrice) {
        // If only b4b-compare-at-price exists, remove price--sale class
        if (!b4bPrice && b4bCompareAtPrice) {
          removeSaleClassIfOnlyComparePrice(productCard);
        }
        badgeElement.style.display = 'none';
        return false;
      }

      const originalPriceText = b4bPrice.textContent.trim();
      const salePriceText = b4bCompareAtPrice.textContent.trim();

      if (!originalPriceText || !salePriceText) {
        // No price text - hide entire badge
        badgeElement.style.display = 'none';
        return false;
      }

      // .compare-at-price.b4b-vprice contains the original/normal price
      // .price.price--sale.b4b-compare-at-price contains the sale price
      const originalPrice = parsePrice(originalPriceText);
      const salePrice = parsePrice(salePriceText);

      // Only show badge if we have valid prices and original price is greater than sale price
      if (originalPrice > 0 && salePrice > 0 && originalPrice > salePrice) {
        const discountAmount = originalPrice - salePrice;
        const discountPercentage = (discountAmount * 100) / originalPrice;
        const roundedPercentage = roundToNearestTen(discountPercentage);

        // Find the discount percentage span and update it
        const badgeContent = badgeElement.querySelector('[data-badge-content]');
        if (badgeContent) {
          let discountSpan = badgeContent.querySelector('[data-discount-percentage]');
          if (discountSpan) {
            // Update the existing span
            discountSpan.textContent = roundedPercentage;
          } else {
            // If span doesn't exist, create it
            badgeContent.innerHTML = `<span data-discount-percentage>${roundedPercentage}</span>% OFF!`;
          }
        }
        
        // Show the entire badge
        badgeElement.style.display = '';
        return true;
      } else {
        // No valid discount - hide the entire badge
        badgeElement.style.display = 'none';
        return false;
      }
    }

    function checkAndHideBadgeIfNoComparePrice(badgeElement, productCard) {
      if (!badgeElement || !productCard) return false;

      const priceContainer = productCard.querySelector('product-price [ref="priceContainer"]') ||
                             productCard.querySelector('[ref="priceContainer"]');
      
      if (!priceContainer) {
        // No price container found - hide entire badge
        badgeElement.style.display = 'none';
        return true;
      }

      // Check if compare-at-price element exists and has content INSIDE the priceContainer
      const compareAtPriceElement = priceContainer.querySelector('.compare-at-price');
      
      // If no compare-at-price element exists, or it's empty, hide the entire badge
      if (!compareAtPriceElement || !compareAtPriceElement.textContent.trim()) {
        badgeElement.style.display = 'none';
        return true; // Indicates badge was hidden
      }
      
      return false; // Compare-at-price exists and has content
    }

    function removeSaleClassIfOnlyComparePrice(productCard) {
      if (!productCard) return;

      const priceContainer = productCard.querySelector('product-price [ref="priceContainer"]') ||
                             productCard.querySelector('[ref="priceContainer"]');
      
      if (!priceContainer) return;

      // Check if only b4b-compare-at-price exists (without b4b-vprice)
      const b4bVpriceElement = priceContainer.querySelector('.b4b-vprice');
      const b4bCompareAtPriceElement = priceContainer.querySelector('.b4b-compare-at-price');
      
      // If only b4b-compare-at-price exists (no b4b-vprice), remove price--sale class
      if (!b4bVpriceElement && b4bCompareAtPriceElement) {
        // The b4b-compare-at-price element itself may have price--sale class
        // Or it might be inside an element with price--sale class
        if (b4bCompareAtPriceElement.classList.contains('price--sale')) {
          b4bCompareAtPriceElement.classList.remove('price--sale');
        } else {
          // Try to find parent element with price--sale class
          const salePriceElement = b4bCompareAtPriceElement.closest('.price--sale');
          if (salePriceElement) {
            salePriceElement.classList.remove('price--sale');
          }
        }
      }
    }

    function checkAndHideBadgeIfB4BElementsMissing(badgeElement, productCard) {
      if (!badgeElement || !productCard) return false;

      const priceContainer = productCard.querySelector('product-price [ref="priceContainer"]') ||
                             productCard.querySelector('[ref="priceContainer"]');
      
      if (!priceContainer) {
        // No price container found - hide entire badge
        badgeElement.style.display = 'none';
        return true;
      }

      // Check if BOTH required elements exist INSIDE the priceContainer:
      // 1. An element with .b4b-vprice class (original price)
      // 2. An element with .b4b-compare-at-price class (sale price)
      const b4bVpriceElement = priceContainer.querySelector('.b4b-vprice');
      const b4bCompareAtPriceElement = priceContainer.querySelector('.b4b-compare-at-price');
      
      // If either is missing, hide the entire badge - no discount
      if (!b4bVpriceElement || !b4bCompareAtPriceElement) {
        // If only b4b-compare-at-price exists, remove price--sale class
        if (!b4bVpriceElement && b4bCompareAtPriceElement) {
          removeSaleClassIfOnlyComparePrice(productCard);
        }
        badgeElement.style.display = 'none';
        return true; // Indicates badge was hidden
      }
      
      return false; // Both elements exist
    }

    function initializeCollectionBadges() {
      // Check if we're on a collection page
      const mainElement = document.querySelector('main[data-template^="collection"]');
      if (!mainElement) return;

      // B4B app injects .b4b-vprice / .b4b-compare-at-price. When that app is off,
      // keep Liquid sale badges (including split-color corrected badges) as-is.
      if (!document.querySelector('.b4b-vprice, .b4b-compare-at-price')) {
        return;
      }

      // Find all product cards on collection pages
      const productCards = mainElement.querySelectorAll('product-card');
      
      productCards.forEach(function(productCard) {
        const productId = productCard.dataset.productId;
        if (!productId) return;

        // Find badge - try with product ID first, then try without
        let badge = productCard.querySelector(`.product-badges[data-product-id="${productId}"]`);
        if (!badge) {
          badge = productCard.querySelector('.product-badges');
        }
        if (!badge) return;

        // First, check if compare-at-price exists - if not, hide badge immediately
        if (checkAndHideBadgeIfNoComparePrice(badge, productCard)) {
          return;
        }

        // Check if both b4b elements exist - if not, hide badge immediately
        // This will also remove price--sale class if only b4b-compare-at-price exists
        if (checkAndHideBadgeIfB4BElementsMissing(badge, productCard)) {
          return;
        }

        // Try to update badge immediately and retry if elements not found (they might load dynamically)
        let attempts = 0;
        const maxAttempts = 15;
        
        function tryUpdate() {
          // Re-check compare-at-price on each attempt
          if (checkAndHideBadgeIfNoComparePrice(badge, productCard)) {
            return; // Badge was hidden, stop trying
          }

          // Re-check b4b elements on each attempt
          if (checkAndHideBadgeIfB4BElementsMissing(badge, productCard)) {
            return; // Badge was hidden, stop trying
          }
          
          const success = updateBadgeFromB4B(badge, productCard);
          
          if (success) {
            // Successfully updated, set up observer to watch for changes
            const priceContainer = productCard.querySelector('product-price [ref="priceContainer"]') ||
                                   productCard.querySelector('[ref="priceContainer"]');
            
            if (priceContainer) {
              // Watch the entire price container for any changes
              const observer = new MutationObserver(function() {
                // Check if compare-at-price still exists
                if (checkAndHideBadgeIfNoComparePrice(badge, productCard)) {
                  return; // Badge was hidden, no need to update
                }
                // Check if both b4b elements still exist
                if (checkAndHideBadgeIfB4BElementsMissing(badge, productCard)) {
                  return; // Badge was hidden, no need to update
                }
                updateBadgeFromB4B(badge, productCard);
              });

              observer.observe(priceContainer, {
                childList: true,
                subtree: true,
                characterData: true
              });
            }
            
            // Also watch individual b4b elements if they exist in the price container
            // Only watch elements within the price container (both must exist for discount)
            const b4bPrice = priceContainer.querySelector('.b4b-vprice');
            const b4bCompareAtPrice = priceContainer.querySelector('.b4b-compare-at-price');

            // Only set up observers if both elements exist
            if (b4bPrice && b4bCompareAtPrice) {
              const priceObserver = new MutationObserver(function() {
                if (checkAndHideBadgeIfNoComparePrice(badge, productCard)) {
                  return;
                }
                if (checkAndHideBadgeIfB4BElementsMissing(badge, productCard)) {
                  return;
                }
                updateBadgeFromB4B(badge, productCard);
              });
              priceObserver.observe(b4bPrice, {
                childList: true,
                subtree: true,
                characterData: true
              });

              const compareObserver = new MutationObserver(function() {
                if (checkAndHideBadgeIfNoComparePrice(badge, productCard)) {
                  return;
                }
                if (checkAndHideBadgeIfB4BElementsMissing(badge, productCard)) {
                  return;
                }
                updateBadgeFromB4B(badge, productCard);
              });
              compareObserver.observe(b4bCompareAtPrice, {
                childList: true,
                subtree: true,
                characterData: true
              });
            }
          } else if (attempts < maxAttempts) {
            // Retry if elements not found yet
            attempts++;
            setTimeout(tryUpdate, 200);
          } else {
            // After all attempts, check one more time if compare-at-price exists
            // If it doesn't exist, hide the badge
            checkAndHideBadgeIfNoComparePrice(badge, productCard);
          }
        }
        
        // Start the update process
        tryUpdate();
      });
    }

    function updateBadgeForVariant(badgeElement, variant) {
      if (!badgeElement || !variant) return;

      const badgeContent = badgeElement.querySelector('[data-badge-content]');
      const discountSpan = badgeElement.querySelector('[data-discount-percentage]');
      
      if (!badgeContent) {
        // Badge content doesn't exist yet, check if we need to create it
        if (variant.compare_at_price && variant.price && variant.compare_at_price > variant.price && variant.available) {
          // Create badge content
          const badgeWrapper = badgeElement.querySelector('.product-badges__badge--rectangle') || badgeElement;
          const newBadgeContent = document.createElement('div');
          newBadgeContent.className = 'product-badges__badge product-badges__badge--rectangle color-accent-1';
          newBadgeContent.setAttribute('data-badge-content', '');
          
          const discountAmount = variant.compare_at_price - variant.price;
          const discountPercentage = Math.floor((discountAmount * 100) / variant.compare_at_price);
          
          newBadgeContent.innerHTML = `<span data-discount-percentage>${discountPercentage}</span>% OFF!`;
          badgeWrapper.appendChild(newBadgeContent);
          return;
        }
        return;
      }

      // Check if variant has a discount
      if (variant.compare_at_price && variant.price && variant.compare_at_price > variant.price && variant.available) {
        const discountAmount = variant.compare_at_price - variant.price;
        const discountPercentage = Math.floor((discountAmount * 100) / variant.compare_at_price);

        if (discountSpan) {
          discountSpan.textContent = discountPercentage;
        }
        badgeContent.style.display = '';
      } else if (!variant.available) {
        // Show sold out - keep existing sold out text or hide
        badgeContent.style.display = '';
        if (discountSpan) {
          discountSpan.textContent = '';
        }
        // Don't change innerHTML, keep existing sold out text from Liquid
      } else {
        // Hide badge if no discount
        badgeContent.style.display = 'none';
      }
    }

    document.addEventListener(ThemeEvents.variantUpdate, function(event) {
      // Skip variant updates on collection pages - use b4b prices instead
      const mainElement = document.querySelector('main[data-template^="collection"]');
      if (mainElement) return;

      const updatedHTML = event.detail?.data?.html;
      if (!updatedHTML) return;

      // Extract variant data from JSON script tag (same way variant-picker does it)
      const variantPickerScript = updatedHTML.querySelector('variant-picker script[type="application/json"]');
      if (!variantPickerScript) return;

      let variant;
      try {
        variant = JSON.parse(variantPickerScript.textContent);
      } catch (e) {
        return;
      }

      if (!variant || !variant.id) return;

      // Find the product card that triggered this event
      const productCard = event.target.closest('product-card');
      if (!productCard) return;

      const productId = productCard.dataset.productId;
      if (!productId) return;

      const badge = productCard.querySelector(`.product-badges[data-product-id="${productId}"]`);
      if (!badge) return;

      updateBadgeForVariant(badge, variant);
    });

    // Initialize collection page badges on load
    function runInitialization() {
      initializeCollectionBadges();
      // Also run after a delay to catch dynamically loaded content
      setTimeout(initializeCollectionBadges, 500);
      setTimeout(initializeCollectionBadges, 1000);
      setTimeout(initializeCollectionBadges, 2000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runInitialization);
    } else {
      runInitialization();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
